<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить шаблон квитанции</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'bill-templates' }">← Назад к Шаблонам квитанций</router-link>
    </div>

    <h4>Доступные переменные</h4>
    <p>
      <strong>{contract_number}</strong> &ndash; номер договора<br>
      <strong>{debp}</strong> &ndash; сумма долга<br>
      <strong>{apartment}</strong> &ndash; номер квартиры<br>
      <strong>{block}</strong> &ndash; номер подъезда<br>
      <strong>{building}</strong> &ndash; номер дома<br>
      <strong>{street}</strong> &ndash; улица<br>
      <strong>{district}</strong> &ndash; район<br>
      <strong>{city}</strong> &ndash; город<br>
    </p>

    <bill-template-add-form @after="handleAfter" />

  </div>
</template>

<script>
import billTemplateAddForm from '@/components/forms/bill_template/BillTemplateAddForm'

export default {
  name: 'bill-template-add',
  components: { billTemplateAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'bill-templates' })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BillTemplateAdd.vue?391812d3